import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';

export class CustomerSerializer implements Serializer {
	fromJson(json: any): Customer {
		let customer = new Customer(json);
		return customer;
	}

	toJson(customer: Customer): any {
		return customer;
	}
}

export class Customer implements Resource {
	public id: number;
	public uuid: string;
	public first_name: string = null;
	public last_name: string = null;
	public full_name: string;
	public email: string;
	public dial_code: string;
	public phone: string;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);

			if (!input.full_name && input.first_name) {
				this.full_name = this.first_name + ' ' + this.last_name;
			}
		}
	}
}